import { configureStore, type Middleware } from '@reduxjs/toolkit';

// Configure RestClient before sagas run
import '../../network/configureRestClient';

import listenerMiddleware, { addAppListenersToMiddleware } from './listenerMiddleware';
import { middlewares } from './middlewares';
import { initReducers } from './reducers';
import { runSagas } from './sagas';

const store = configureStore({
  middleware: (getDefaultMiddleware) => {
    const defaultMiddleware = getDefaultMiddleware({ serializableCheck: false });
    return defaultMiddleware
      .prepend(listenerMiddleware.middleware as Middleware)
      .concat(...(middlewares as readonly Middleware[]));
  },
  reducer: initReducers(),
  devTools: process.env.NODE_ENV === 'development',
});

addAppListenersToMiddleware();

runSagas();

export default store;
